<template>
  <div>
    <div style="margin-bottom: 10px">
      <el-button v-if="limits.addAuth" type="primary" @click="$refs.materialTypeNameEdit.open()">新建一级</el-button>
    </div>
    <el-table 
        v-loading="contentLoading" 
        :data="tableData" 
        row-key="pkid" 
        border 
        stripe 
        :tree-props="{ children: 'children' }">
      <el-table-column prop="materialTypeNo" label="编号" width="120"/>
      <el-table-column prop="materialTypeName" label="名称"/>
      <el-table-column label="操作" align="center" width="190">
        <template slot-scope="scope">
          <el-button v-if="limits.editAuth" size="mini" type="primary" @click="$refs.materialTypeNameEdit.open(scope.row, 1)">编辑</el-button>
          <el-button v-if="limits.addNextAuth" size="mini" type="primary" @click="$refs.materialTypeNameEdit.open(scope.row, 0)">添加下级</el-button>
          <el-button v-if="limits.delAuth" size="mini" type="danger" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <material-type-name-edit ref="materialTypeNameEdit" @save-success="getData"/>
  </div>
</template>

<script>
  import MaterialTypeNameEdit from "./MaterialTypeNameEdit";
  export default {
    name: "MaterialTypeNameTree",
    components: {
      MaterialTypeNameEdit,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(129),
          addNextAuth: this.$auth(130),
          editAuth: this.$auth(131),
          delAuth: this.$auth(132),
        },
        tableData: [],
        contentLoading: false,
      };
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", "materialTypes/tree")
          .then((res) => {
            if (res.success) {
              this.tableData = res.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "materialTypes", row.pkid).then((resp) => {
            if (resp.success) {
              this.getData();
              this.$message.success("删除成功");
            }
          });
        });
      },
    },
  };
</script>
